import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { WhatsappTrialService } from '../services/whatsapp-trial.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-whatsapp-paywall',
  templateUrl: './whatsapp-paywall.component.html',
  styleUrls: ['./whatsapp-paywall.component.scss']
})
export class WhatsappPaywallComponent implements OnInit {
  loading = false;
  empresa: any = {};

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private whatsappTrialService: WhatsappTrialService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    // A verificação do status do trial é feita pelo WhatsappTrialResolver
    // antes mesmo de carregar este componente, evitando que a tela seja exibida
    // desnecessariamente quando o trial já estiver ativo
    this.carregarDadosEmpresa();
  }

  carregarDadosEmpresa() {
    this.http.get<any>('/api/empresa').subscribe(
      (empresa: any) => {
        this.empresa = empresa;
      },
      (erro) => {
        console.error('Erro ao carregar dados da empresa:', erro);
      }
    );
  }

  iniciarTrialGratis() {
    this.loading = true;
    const destino = this.obtenhaDestinoPosLiberacao();

    this.whatsappTrialService.ativarTrial()
      .then((resposta: any) => {
        this.loading = false;
        this.notificationService.showSuccess('Trial ativado com sucesso! Aproveite os 30 dias gratuitos.');
        if (destino === '/admin/cloud-whatsapp/config') {
          this.router.navigate(['/admin/cloud-whatsapp/config'], {
            queryParams: { trialAtivado: 'true' }
          });
          return;
        }

        this.router.navigateByUrl(destino);
      })
      .catch((erro) => {
        this.loading = false;
        this.notificationService.showError('Não foi possível ativar o trial. Tente novamente ou contate o suporte.');
        console.error('Erro ao ativar trial:', erro);
      });
  }

  assinarAgora() {
    this.loading = true;
    const destino = this.obtenhaDestinoPosLiberacao();

    this.http.post<any>('/api/cloud-whatsapp/assinar', {})
      .subscribe(
        (resposta: any) => {
          this.loading = false;
          if (resposta && resposta.sucesso) {
            this.router.navigateByUrl(destino);
          }
        },
        (erro) => {
          console.error('Erro ao processar assinatura:', erro);
          this.loading = false;
        }
      );
  }

  contatarSuporte() {
    // Implementar funcionalidade para contatar suporte
    window.open('https://wa.me/5562983239457?text=Oi,%20quero%20saber%20mais%20sobre%20Whatsapp%20Oficial', '_blank');
  }

  private obtenhaDestinoPosLiberacao(): string {
    const redirectTo = this.route.snapshot.queryParamMap.get('redirectTo');

    if (redirectTo && redirectTo.startsWith('cloud-whatsapp/')) {
      return `/admin/${redirectTo}`;
    }

    return '/admin/cloud-whatsapp/config';
  }
}
